export default "__VITE_ASSET__BF84_9EV__"